import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";

type Option = {
  id: string;
  label: string;
};

type DropdownProps = {
  label: string;
  options: Option[];
  value?: string;
  onChange: (value: string) => void;
};

const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  value,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Find the selected option
  const selected = options.find((opt) => String(opt.id) === String(value)) || {
    id: "",
    label: "الكل",
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Simplified approach - no portals, directly render menu in component
  return (
    <div className={styles.dropdown} ref={containerRef}>
      <div
        className={styles.labelRow}
        onClick={() => {
          setOpen(!open);
        }}>
        <div className={styles.labelContainer}>
          <span className={styles.label}>{label}:</span>
          <span className={styles.selectedLabel}>{selected.label}</span>
        </div>
        <img
          src="/assets/images/svg/drop_down_arrow.svg"
          alt="Toggle Dropdown"
        />
      </div>

      {open && (
        <div className={styles.menuContainer}>
          <ul className={styles.menu}>
            {options.map((opt) => (
              <li
                key={String(opt.id)}
                className={`${styles.menuItem} ${
                  String(opt.id) === String(value) ? styles.selected : ""
                }`}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event bubbling
                  try {
                    onChange(opt.id);
                  } catch (err) {
                    console.error("Error in onChange:", err);
                  }
                  setOpen(false);
                }}>
                {opt.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
